module.exports = __webpack_public_path__ + "img/2.3dbe4223.png";